import { ContributorType } from "@/src/types";
import { Card, CardBody, Typography } from "@material-tailwind/react";
import Link from "next/link";
import React from "react";
import ContributorSocials from "../contributor/socials";
import Image from "next/image";

const ContributorCard = ({ contributor }: { contributor: ContributorType }) => {
  return (
    <Link
      href={contributor.uri}
      className={"contributor-card shadow-2xl w-full md:w-[48%]"}
    >
      <Card style={{ borderRadius: 0, height: "100%" }}>
        <CardBody className="p-0">
          <div className={"flex h-[100%] flex-col"}>
            <div className="image pb-[100%] min-h-[300px] relative w-full">
              <Image
                src={contributor?.contributormeta?.image?.node?.mediaItemUrl}
                fill
                alt={`${contributor?.name} profile picture`}
              />
            </div>

            <div className={"p-4 flex gap-1 flex-col text-container"}>
              <div className="flex gap-2">
                <Typography
                  variant="paragraph"
                  className={"text-black text-xl font-bold"}
                >
                  {contributor?.name}
                </Typography>
                <ContributorSocials contributor={contributor} />
              </div>
              <Typography variant="paragraph">
                {contributor?.contributormeta?.bio}
              </Typography>
            </div>
          </div>
        </CardBody>
      </Card>
    </Link>
  );
};

export default ContributorCard;
